<template>
  <div class="bg-gradient-to-b from-[#B0D0FF]/70 h-36 w-[100%] absolute left-0 top-0 pointer-events-none" />

  <div class="flex w-full justify-between mb-6">
    <div class="relative z-10">
      <div class="flex space-x-4 items-center text-2xl font-medium">
        <ClipboardPaste color="black" />
        <div>{{ $t("Send Survey") }}</div>
      </div>
      <div class="text-common-grey text-sm">
        {{ $t("Send a survey to your customers, having the results mapped in RevSetter.") }}
      </div>
    </div>
    <button class="primary-btn btn w-fit h-10" @click="$emitter.emit(ALL_EMITTERS.CREATE_A_SURVEY, { records })">
      <Plus class="w-5 h-5 right-2 text-white mr-2" /> {{ $t("Create New Survey") }}
    </button>
  </div>
  <div class="relative w-full">
    <TextInput
      :label="$t('Survey Name')"
      :value="search_term"
      :is-box-background="false"
      :validate-on-input="true"
      input-classes="appearance-none block w-full px-2 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
      name="search_name"
      type="text"
      :placeholder="$t('Survey Name')"
      class="mb-4"
      @input="
        ($event) => {
          search_term = $event.target.value
        }
      " />

    <RotateCw
      :class="{
        'animate-spin': surveys_loading,
        'opacity-100': surveys_loading
      }"
      class="w-5 h-5 mr-3 -ml-1 opacity-0 absolute right-2 top-2"
      aria-hidden="true" />
  </div>
  <div class="max-h-[300px] overflow-auto w-full mb-20 mt-2">
    <div v-if="surveys_loading && !surveys.results.length" class="mb-10">
      {{ $t("Loading...") }}
    </div>
    <div
      v-for="survey in surveys.results"
      :key="survey.id"
      class="flex items-center border-b py-4 pl-2 cursor-pointer hover:bg-gray-100 transition-all ease-in-out"
      @click.stop="selected_suvery = survey.id">
      <input
        :checked="selected_suvery == survey.id"
        type="checkbox"
        class="mr-5 pointer-events-none form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:!bg-light-brand-blue dark:checked:bg-dark-brand-blue dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-light-divider-border w-6 rounded-full h-6 transition ease-in-out duration-side-menu-transition-duration">
      <div>{{ survey.name }}</div>
    </div>
    <div class="absolute w-[90%] h-6 overflow-visible bg-white bottom-24 dark:bg-dark-box-background">
      <PaginationFooter :default-page-size="page_size" :object="surveys" @update="handlePaginationUpdate" />
    </div>
  </div>

  <div class="flex w-full justify-between">
    <button class="text-light-brand-blue" @click="$emit('cancel')">{{ $t("Cancel") }}</button>

    <button class="btn primary-btn w-fit" :class="{ 'opacity-60 pointer-events-none': !selected_suvery }" @click="sendSurvey">
      {{ $t("Send Survey") }} <span class="rounded-md bg-dark-brand-blue p-0.5 ml-2 px-1.5">{{ records.length }}</span>
    </button>
  </div>
</template>

<script>
import dataService from "@/services/data.service"
import PaginationFooter from "@/components/shared/PaginationFooter.vue"
import TextInput from "@/components/shared/TextInput.vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import { ClipboardPaste, Plus, RotateCw } from "lucide-vue-next"

export default {
  components: {
    ClipboardPaste,
    TextInput,
    PaginationFooter,
    RotateCw,
    Plus
  },
  props: {
    records: null
  },
  emits: ["done", "cancel"],
  data() {
    return {
      ALL_EMITTERS,
      surveys: { results: [] },
      page_size: 20,
      search_term: "",
      search_timout: null,
      selected_suvery: null,
      surveys_loading: false
    }
  },
  watch: {
    search_term() {
      clearTimeout(this.search_timout)
      this.search_timout = setTimeout(() => {
        this.getSurveys()
      }, 500)
    }
  },

  activated() {
    this.register_listeners()
  },

  created() {
    this.register_listeners()
    this.getSurveys()
  },

  unmounted() {
    this.unregister_listeners()
  },
  deactivated() {
    this.unregister_listeners()
  },

  methods: {
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.SURVEY_CREATED_INSIDE_SURVEY_SELECTION_FORM, () => {
        this.getSurveys(1, this.page_size, true)
      })
    },
    unregister_listeners() {
      this.$emitter.off(ALL_EMITTERS.SURVEY_CREATED_INSIDE_SURVEY_SELECTION_FORM)
    },

    handlePaginationUpdate({ page, page_size }) {
      this.getSurveys(page, page_size)
      this.page_size = page_size
    },
    getSurveys(page = 1, page_size = this.page_size, select_survey) {
      this.surveys_loading = true
      const params = { page, page_size }
      if (this.search_term) {
        params["search"] = this.search_term
      }
      dataService.getSurveys(params).then((result) => {
        this.surveys_loading = false
        this.surveys = result.data
        if (select_survey) {
          this.selected_suvery = result.data.results[0].id
        }
      })
    },

    sendSurvey() {
      dataService.sendSurvey(this.selected_suvery, { records: this.records }).then(() => {
        this.$emit("done")
      })
    }
  }
}
</script>
